import React, { Fragment } from 'react';
import { Modal } from './Modal';
import { FormSelect } from '../form/FormSelect';
import { Button } from '../Button';
import { FormInput } from 'components/form/FormInput';
import './ModalPricesUpdate.scss';
/**
 * @component ModalPricesUpdate
 * @since 1.0.0
 * @hidden
 */
export function ModalPricesUpdate(props) {
    const { onClose, processing } = props;
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: onClose, noPadding: true }),
        React.createElement("div", { className: "modal-prices-update-button-container" },
            React.createElement(Button, { style: "primary", label: t('Apply'), disabled: processing, processing: processing, submit: true }))));
    return (React.createElement("div", { className: "modal-prices-update" },
        React.createElement(Modal, { picto: "pen-to-square", title: t('Update Prices'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "modal-prices-update-content" },
                React.createElement(FormSelect, { name: "changeType", label: t('Update Prices'), placeholder: t('What action do you want to do?'), options: [
                        { label: t('Increase'), value: 'INCREASE' },
                        { label: t('Reduction'), value: 'DECREASE' }
                    ], required: true }),
                React.createElement(FormInput, { name: "percentage", type: "number", label: t('%'), defaultValue: "0", placeholder: t('Enter %'), required: true, min: "0" })))));
}
